import { Routes, Route } from "react-router-dom";
import SitesList from "../pages/SitesList"; // Your upload page
import SiteDetails from "../pages/SiteDetails";
import CodingSheet from "../pages/CodingSheet";
import Upload from "../pages/Upload"; // Your upload page
import AddSite from "../pages/AddSite";
import EditSite from "../pages/EditSite"; // Your upload page
import CostCodesList from "../pages/CostCodesList";
import AddCode from "../pages/AddCode";
import EditCode from "../pages/EditCode";
import UserList from "../pages/UserList";
import EditUser from "../pages/EditUser";
import EmailTemplates from "../pages/EmailTemplates";
import EditTemplate from "../pages/EditTemplate";
import AddUser from "../pages/AddUser";
import Logs from "../pages/Logs";
import DBLogs from "../pages/DBLogs";
import EmailQueue from "../pages/EmailQueue";
import { useSession } from "../components/SessionProvider";
import DBViewer from "../pages/DBViewer";
import NotFound from "../pages/NotFound";
import Settings from "../pages/Settings";
import AddBudgetLines from "../pages/AddBudgetLines";
const AppRoutes = () => {
    const { userLogin } = useSession();
    return (
        <Routes>
            <Route path="/" element={<SitesList />} />
            <Route path="/projects/:siteId" element={<SiteDetails />} />
            <Route path="/coding-sheet/:siteId/:invoiceDate" element={<CodingSheet />} />


            {userLogin && userLogin.isAdmin && (
                <>
                    <Route path="/upload" element={<Upload />} />
                    <Route path="/cost-codes" element={<CostCodesList />} />
                    <Route path="/add-code" element={<AddCode />} />
                    <Route path="/edit-code/:codeId" element={<EditCode />} />
                    <Route path="/add-budget-lines" element={<AddBudgetLines />} />
                    <Route path="/add-project" element={<AddSite />} />
                    <Route path="/edit-project/:siteId" element={<EditSite />} />
                    <Route path="/users" element={<UserList />} />
                    <Route path="/edit-user/:email" element={<EditUser />} />
                    <Route path="/email-templates" element={<EmailTemplates />} />
                    <Route path="/edit-template/:templateId" element={<EditTemplate />} />
                    <Route path="/add-user" element={<AddUser />} />
                    <Route path="/logs" element={<Logs />} />
                    <Route path="/dblogs" element={<DBLogs />} />
                    <Route path="/email-queue" element={<EmailQueue />} />
                    <Route path="/dbviewer" element={<DBViewer />} />
                    <Route path="/settings" element={<Settings />} />
                </>

            )}

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default AppRoutes;
